<!-- App.vue -->

<template>
  <div class="mycontent open-sans">
    <div class="nav-progress-bar" :class="{ active: navigating }"></div>
    <div class="ticker-wrapper" :class="{ 'ticker-visible': $route.name === 'Home' && tickerData }">
      <div class="ticker-inner">
        <div v-if="tickerData" class="ticker oswald-bold py-3">
          <a v-if="tickerData.useLink" :href="tickerData.hyperlink" class="ticker-link">{{ tickerData.text }}</a>
          <span v-else>{{ tickerData.text }}</span>
        </div>
      </div>
    </div>
    <Nav :bgColor="$route.meta.navBgColor || '#E35B4B'" :inverse="$route.meta.navInverse || false" />
    <router-view v-slot="{ Component }">
      <transition name="page" mode="out-in">
        <component :is="Component" :key="$route.path" />
      </transition>
    </router-view>
  </div>
</template>


<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { useRouter } from 'vue-router'
import Nav from '@/components/Nav.vue'
import axios from 'axios'

const navigating = ref(false)
const tickerData = ref(null)
const router = useRouter()

router.beforeEach(() => { navigating.value = true })
router.afterEach(() => { setTimeout(() => { navigating.value = false }, 400) })


onMounted(async () => {
  try {
    const res = await axios.post('https://api.atlasimprov.com/graphql/', {
      query: `query { ticker { text useLink hyperlink } }`
    }, {
      headers: { 'Authorization': 'Bearer Pm4Nd5_e46HaK2xtkPcla2PMBzbk9AQf', 'Content-Type': 'application/json' }
    })
    tickerData.value = res.data.data.ticker
  } catch (e) { /* ignore */ }
})

// Fire a GA4 "connect_to_CW" event whenever a link to a CrowdWork resource is clicked
let cwClickHandler = null
onMounted(() => {
  cwClickHandler = (e) => {
    const a = e.target && e.target.closest ? e.target.closest('a') : null
    if (!a) return
    const href = a.href || a.getAttribute('href') || ''
    if (href.includes('crowdwork.com') && typeof window.gtag === 'function') {
      window.gtag('event', 'connect_to_CW', {
        link_url: href,
        link_text: (a.textContent || '').trim().slice(0, 100),
        page_path: window.location.pathname + window.location.search
      })
    }
  }
  document.addEventListener('click', cwClickHandler, true)
})
onBeforeUnmount(() => {
  if (cwClickHandler) document.removeEventListener('click', cwClickHandler, true)
})
</script>

<style>
.ticker-wrapper {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.35s ease;
}
.ticker-wrapper.ticker-visible {
  grid-template-rows: 1fr;
}
.ticker-inner {
  overflow: hidden;
  min-height: 0;
}
.ticker {
  width: 100%;
  background-color: #000;
  color: #fff;
  text-align: center;
}
.ticker-link {
  color: #fff;
  text-decoration: none;
}

.nav-progress-bar {
  position: fixed;
  top: 0;
  left: 0;
  height: 3px;
  width: 0%;
  background: var(--atlas-blue, #1a73e8);
  z-index: 9999;
  transition: width 0s;
  opacity: 0;
}
.nav-progress-bar.active {
  width: 85%;
  opacity: 1;
  transition: width 8s cubic-bezier(0.1, 0.05, 0, 1), opacity 0.1s;
}
</style>
